<template>
    <Paper class="cute-consent-dialog p-4">
        <div class="d-flex align-items-center justify-content-center">
            <img class="logo" :src="cuteLogo" />
        </div>
        <h5 class="text-center mb-2">{{ $t('tests.cute.dialog.header') }}</h5>

        <div
            class="d-flex align-items-center"
            style="max-width:400px;margin:auto;"
        >
            <BaseCheckbox class="consent-toggle mr-2" v-model="consented" />
            <p class="text-center caption mute">
                {{ $t('tests.cute.dialog.consent') }}
            </p>
        </div>
        <BaseButton
            class="w-100 d-flex align-items-center justify-content-center"
            variant="primary"
            :disabled="!consented || isLoading"
            @click="onConsent"
        >
            <Spinner class="mr-2" v-if="isLoading" size="sm" />
            {{ $t('tests.cute.startTest') }}
        </BaseButton>

        <IconBtn
            @click="onClose"
            style="position: absolute; top:4px;right:4px;"
            name="times"
            size="sm"
        />
    </Paper>
</template>

<script>
// Assets
import CuteSvg from '~/assets/img/cut-e.svg';

export default {
    name: 'ConsentDialog',
    props: {
        link: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        cuteLogo: CuteSvg,
        consented: false,
        isLoading: false,
    }),
    methods: {
        onConsent() {
            this.isLoading = true;
            this.$interfaces.candidate.test['cut-e']
                .put({
                    body: { consented: true },
                })
                .then(() => {
                    this.$emit('consented');
                    this.onClose();
                    window.open(this.link, '_blank');
                })
                .catch(() => {
                    MessageService.error(
                        this.$t('tests.cute.consentErrorTitle'),
                        this.$t('tests.cute.consentErrorMessage')
                    );
                })
                .finally(() => (this.isLoading = false));
            return;
        },
        onClose() {
            this.$emit('close');
        },
    },
};
</script>

<style scoped>
.cute-consent-dialog {
    max-width: 600px;
    position: relative;
}

.logo {
    width: 100px;
    height: auto;
    max-height: 100px;
    object-fit: scale-down;
}

.consent-toggle {
    z-index: 4;
}
</style>
